import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { READ_TIME_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';
export const READ_TIME_METRIC = createPageSegmentLoadMetric({
	key: READ_TIME_SEGMENT_KEY,
});
